// eslint-disable-next-line no-restricted-imports
import {
  CreateLegalClientByAdminDto_Input,
  MutationInput_LegalClientController_Create_Input_Representative_RoleInCompany_CivilLawSubject,
  MutationInput_LegalClientController_Create_Input_Representative_RoleInCompany_RoleInCompany,
} from 'api/generated/graphql';
import { CivilLawSubjectType, RoleInCompanyType } from 'api/types/entity';
import { CreateLegalClientParam } from 'api/types/params';
import { formatToISODate } from 'helpers';

export const parseCreateLegalClientParam = (
  data: CreateLegalClientParam
): CreateLegalClientByAdminDto_Input => ({
  fullName: data.fullName,
  personalAccount: {
    number: data.personalAccountNumber,
    openingDate: formatToISODate(data.personalAccountOpeningDate),
  },
  fullySignedClientServiceAgreementFileId_Global:
    data.companySignedClientServiceAgreementFileId_Global,
  companySignedNoticeOfInvestmentAccountOpeningFileId:
    data.companySignedNoticeOfInvestmentAccountOpeningFileId,
  brightCode: data.brightCode,
  serviceContractFileId_Finance: data.serviceContractFileId_Finance,
  representative: {
    email: data.representative.email,
    firstName: data.representative.firstName,
    lastName: data.representative.lastName,
    middleName: data.representative.middleName,
    phoneNumber: data.representative.phoneNumber,
    dateOfBirth: formatToISODate(data.representative.dateOfBirth),
    roleInCompany: {
      authorityConfirmationDocument: {
        dateOfExpiration: data.representative.roleInCompany.dateOfExpiration
          ? formatToISODate(data.representative.roleInCompany.dateOfExpiration)
          : undefined,
        dateOfIssue: formatToISODate(
          data.representative.roleInCompany.dateOfIssue
        ),
      },
      roleInCompany:
        MutationInput_LegalClientController_Create_Input_Representative_RoleInCompany_RoleInCompany[
          data.representative.roleInCompany.roleInCompany
        ],
      civilLawSubject:
        data.representative.roleInCompany.roleInCompany ===
        RoleInCompanyType.AuthorizedRepresentative
          ? MutationInput_LegalClientController_Create_Input_Representative_RoleInCompany_CivilLawSubject[
              data.representative.roleInCompany.civilLawSubject!
            ]
          : undefined,
    },
    companyFullName:
      data.representative.roleInCompany.civilLawSubject ===
      CivilLawSubjectType.JuridicalPerson
        ? data.representative.companyFullName
        : undefined,
  },
});
